import { type Fetcher, useNavigation } from '@remix-run/react'
import * as React from 'react'

import { ToastContext } from '~/components/ui/toast'
import { type App } from '~/routes/_layout/root.component'

type UseNotifyProps = Fetcher & {
	search?: any
	same?: boolean
	subaction?: string
	setApp: React.Dispatch<React.SetStateAction<App>>
	translations: {
		success: {
			title: string | React.ReactNode
			description: string | React.ReactNode
		}
		error?: {
			title: string | React.ReactNode
			description: string | React.ReactNode
		}
	}
	successCallback?: () => void
	errorCallback?: () => void
}

function useNotify({
	formData,
	state,
	data,
	subaction,
	same = true,
	search,
	errorCallback,
	successCallback,
	translations,
}: UseNotifyProps) {
	const navigation = useNavigation()
	const { addToast } = React.useContext(ToastContext)!

	React.useEffect(() => {
		if (
			(formData &&
				(!subaction || formData.get('subaction') === subaction) &&
				same) ||
			search
		) {
			if (
				navigation.state === 'loading' ||
				(state === 'loading' &&
					// @ts-ignore
					data?.status >= 200 &&
					// @ts-ignore
					data?.status < 300) ||
				search
			) {
				addToast({
					message: translations.success.title as string,
					description: translations.success.description as string,
					type: 'green',
				})
				if (successCallback) {
					successCallback()
				}
			} else if (data && translations.error && state === 'loading') {
				addToast({
					message: translations.error.title as string,
					description: translations.error.description as string,
					type: 'red',
				})
				if (errorCallback) {
					errorCallback()
				}
			}
		}
	}, [
		data,
		formData,
		state,
		navigation.state,
	])
}

export { useNotify }
